import React from 'react';
import PropTypes from 'prop-types';
import './Card.scss';

const Card = ({
  children,
  title,
}) => (
  <div className="card">
    {title && (
      <>
        <div className="title">
          <h4>{title}</h4>
        </div>
        <hr />
      </>
    )}
    <div className="body">
      {children}
    </div>
  </div>
);

Card.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

Card.defaultProps = {
  children: undefined,
  title: undefined,
};

export default Card;
